import {LoadingButton} from '@mui/lab';
import {Button} from '@mui/material';
import React, {useState} from 'react';
import {toast} from 'react-toastify';
import CopyButton from 'src/components/buttons/CopyButton';
import {requestUserInputs} from 'src/components/modals/BasicDynamicFormModal';
import {request} from 'src/utils/AdminApi';
import {amountValidation} from 'src/utils/commonValidation';
import {isFeatureAllowed} from 'src/utils/featureUtils';
import handleEpaymentError from 'src/utils/shipping-api/handleEpaymentError';

export default function OrderPaymentLink({order}) {
	const [isLoading, setIsLoading] = useState(false);

	const payment_link = order.custom_fields?.payment_link;
	const [url, setUrl] = useState(payment_link ?? '');

	const payment_link_already_exist = !!payment_link;
	const button_text = !payment_link_already_exist ? 'انشاء رابط دفع الكتروني' : 'انشاء رابط جديد';

	const show_create_button = !url || payment_link_already_exist;
	const already_paid = order.payment?.status === 'confirmed' || order.payment_received;

	if (!isFeatureAllowed('payment_link')) return null;
	if (already_paid) return null;

	return (
		<>
			<img
				src="https://tlync-public.s3.eu-central-1.amazonaws.com/resources/gatewyas-w.png"
				height={30}
				style={{objectFit: 'contain', marginTop: 20}}
			/>
			{show_create_button && (
				<LoadingButton
					loading={isLoading}
					onClick={async () => {
						const values = await requestUserInputs('القيمة', [
							{
								name: 'amount',
								label: 'المبلغ',
								type: 'number',
								required: true,
								value: order.total,
								validation: amountValidation.required('يجب ادخال المبلغ'),
							},
						]);
						try {
							setIsLoading(true);
							const res = await request(`/orders/create-payment-link`, 'POST', {
								order_id: order.id,
								custom_amount: values.amount,
							});

							setUrl(res.payment_result.url);

							navigator.clipboard.writeText(res.payment_result.url).then(() => {
								toast.success('تم نسخ رابط الدفع بنجاح');
							});
						} catch (err) {
							const error = handleEpaymentError(err?.response?.data).join('\n');
							toast.error(error || 'حدث خطأ غير متوقع');
						} finally {
							setIsLoading(false);
						}
					}}
				>
					{button_text}
				</LoadingButton>
			)}

			{url && <CopyButton value={url} label={'نسخ رابط الدفع الالكتروني'} />}
		</>
	);
}
